<template>
  <div>
    <v-header :go-back="true" :mine='true'></v-header>
    <div class="title">{{$t('bindById.inputId')}}</div>
    <div class="iptPic">
      <img src="../../image/inputQr.png" alt="">
      <p>{{$t('bindById.pleaseInput')}}</p>
    </div>
    <div class="iptBox">
      <el-input v-model="input" :placeholder="$t('bindById.pleaseInput')" class="ipt"></el-input>
    </div>
    <button type="button" class="btn" @click="bind">{{$t('bindById.sureBind')}}</button>
  </div>
</template>
<script>
import header from "../../components/header";
import { bindDevice } from "../../deviceApi/index.js";
import { getLoginUser } from "../../api/index.js";
import Qs from "qs";
export default {
  name: "bindById",
  data() {
    return {
      input: ""
    };
  },
  created(){
    //检验是否登录超时
    if (sessionStorage.getItem("login") == 1) {
      getLoginUser()
        .then(res => {
          if (res.data.header.status == 3019) {
            sessionStorage.setItem("login", "1");
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {});
    }
  },
  methods: {
    bind() {
      var str = this.input.substr(0,1);
      if (str == "E"){
        let params = Qs.stringify({
          code: this.input
        });
        bindDevice(params)
          .then(res => {
            // console.log("返回的状态码：",res.data.header.status)
            if (res.data.header.status == 1000) {
              this.$message({
                message: this.$t('bindById.successBind'),
                type: "success",
                center: true
              });
              this.$router.push("/");
            } else {if (res.data.header.status == 80013) {
              this.$message.error(this.$t('bindById.alreadyBinged'));
            } else  {
              this.$message.error(this.$t('bindById.faileBind'));
            }}
          })
          .catch(err => {});
      }else{
        this.$message.error(this.$t('bindById.cannotBind'))
      }
      
    }
  },
  components: {
    "v-header": header
  }
};
</script>
<style>
.ipt .el-input__inner{
  border-radius: 1.3rem;
}
</style>

<style scoped>
.title {
  text-align: center;
  font-size: 0.8rem;
  color: #828282;
  margin-top: 1rem;
}
.iptPic{
  width: 100%;
  text-align: center;
  margin-top: 1rem;
}
.iptPic img{
  width: 50%;
}
.iptPic p{
  color: #7dc3f2;
  font-size: 0.6rem;
  padding: 0.6rem 0;
}
.iptBox {
  text-align: center;
  margin-top: 40px;
}
.ipt {
  width: 72%;
}

.btn {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 20px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
</style>


// WEBPACK FOOTER //
// src/m_page/home/bindById.vue